import React, { Component } from "react";

import Backend from "../utils/Backend";
import Notify from "../utils/Notify";

import StatsCard from "./components/stats-cards/StatsCard";

import ManageVendorsTable from "./components/tables/manage-vendors/ManageVendorsTable";
import VendorPresenceMap from "./components/maps/VendorPresenceMap";

import FetchHelper from "../utils/FetchHelper";


export default class ManageVendors extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stats: null,
      vendorLocations: [],
      vendorMapLoading: false,
    };
  }

  // componentDidMount() {
  //   this._getStats();
  // }

  componentDidMount() {
  this._getStats();
  this._getVendorMapLocations();
}

// _getVendorMapLocations() {
//   this.setState({ vendorMapLoading: true });

//   Backend.getVendorMapLocations()
//     .then((response) => {
//       const records = response?.results || response || [];

//       this.setState({
//         vendorLocations: records.map((record) => ({
//           id: record.id,
//           name: record.name || record.company_name || record.venue_name,
//           county: record.county || record.address?.county,
//           latitude: record.latitude ?? record.address?.latitude,
//           longitude: record.longitude ?? record.address?.longitude,
//           deliveryRadiusKm:
//             record.delivery_radius_km ?? record.delivery_radius ?? 0,
//         })),
//         vendorMapLoading: false,
//       });
//     })
//     .catch((error) => {
//       Notify.error(error.message || "Failed to load vendor locations.");
//       this.setState({ vendorMapLoading: false });
//     });
// }



async _getVendorMapLocations() {
  this.setState({ vendorMapLoading: true });

  try {
    const separator =
      window.Api.Companies.includes("?") ? "&" : "?";

    const url =
      `${window.Api.Companies}${separator}` +
      "page=1&page_size=99999&pagination_type=page&ordering=-created_at";

    const response = await FetchHelper.get(url, false);
    const companies = response?.results || response || [];

    const vendorLocations = companies.reduce(
      (locations, company) => {
        (company?.venues || []).forEach((venue) => {
          /*
           * GeoJSON coordinates use:
           * [longitude, latitude]
           */
          const coordinates =
            venue?.location?.coordinates ||
            venue?.coordinates;

          const address =
            venue?.address ||
            venue?.location?.address ||
            {};

          const latitude =
            venue?.latitude ??
            venue?.location?.latitude ??
            address?.latitude ??
            (Array.isArray(coordinates)
              ? coordinates[1]
              : undefined);

          const longitude =
            venue?.longitude ??
            venue?.location?.longitude ??
            address?.longitude ??
            (Array.isArray(coordinates)
              ? coordinates[0]
              : undefined);

          locations.push({
            id: venue?.id,

            name:
              venue?.title ||
              venue?.name ||
              company?.title ||
              "Vendor location",

            county:
              venue?.county ||
              address?.county ||
              address?.state ||
              "Not provided",

            latitude,
            longitude,

            deliveryRadiusKm:
              venue?.delivery_radius_km ??
              venue?.delivery_radius ??
              venue?.delivery_distance ??
              0,
          });
        });

        return locations;
      },
      []
    );

    this.setState({
      vendorLocations,
      vendorMapLoading: false,
    });
  } catch (error) {
    Notify.error(
      error.message || "Failed to load vendor locations."
    );

    this.setState({
      vendorMapLoading: false,
    });
  }
}

  _getStats() {
    this.setState({ isLoading: true });

    Backend.getVendorsStats()
      .then((stats) => {
        this.setState({ stats, isLoading: false });
      })
      .catch((error) => {
        Notify.error(error.message);
        this.setState({
          isLoading: false,
        });
      });
  }

  render() {
    const { stats } = this.state;

    if (!stats) {
      return null;
    }

    return (
      <div className="container">
        <div className="row wd-100 mb-5">
          <div className="col-lg-6 col-md-6 mb-4">
            <StatsCard
              data={[
                {
                  statsInfo: `${stats?.company_count}`,
                  title: "Total Vendors",
                  icon: (
                    <g
                      stroke="none"
                      strokeWidth={1}
                      fill="none"
                      fillRule="evenodd"
                    >
                      <rect x={0} y={0} width={24} height={24} />
                      <circle
                        fill="#FF5E8A"
                        opacity="0.3"
                        cx={12}
                        cy={12}
                        r={9}
                      />
                      <path
                        d="M11.7357634,20.9961946 C6.88740052,20.8563914 3,16.8821712 3,12 C3,11.9168367 3.00112797,11.8339369 3.00336944,11.751315 C3.66233009,11.8143341 4.85636818,11.9573854 4.91262842,12.4204038 C4.9904938,13.0609191 4.91262842,13.8615942 5.45804656,14.101772 C6.00346469,14.3419498 6.15931561,13.1409372 6.6267482,13.4612567 C7.09418079,13.7815761 8.34086797,14.0899175 8.34086797,14.6562185 C8.34086797,15.222396 8.10715168,16.1034596 8.34086797,16.2636193 C8.57458427,16.423779 9.5089688,17.54465 9.50920913,17.7048097 C9.50956962,17.8649694 9.83857487,18.6793513 9.74040201,18.9906563 C9.65905192,19.2487394 9.24857641,20.0501554 8.85059781,20.4145589 C9.75315358,20.7620621 10.7235846,20.9657742 11.7357634,20.9960544 L11.7357634,20.9961946 Z M8.28272988,3.80112099 C9.4158415,3.28656421 10.6744554,3 12,3 C15.5114513,3 18.5532143,5.01097452 20.0364482,7.94408274 C20.069657,8.72412177 20.0638332,9.39135321 20.2361262,9.6327358 C21.1131932,10.8600506 18.0995147,11.7043158 18.5573343,13.5605384 C18.7589671,14.3794892 16.5527814,14.1196773 16.0139722,14.886394 C15.4748026,15.6527403 14.1574598,15.137809 13.8520064,14.9904917 C13.546553,14.8431744 12.3766497,15.3341497 12.4789081,14.4995164 C12.5805657,13.664636 13.2922889,13.6156126 14.0555619,13.2719546 C14.8184743,12.928667 15.9189236,11.7871741 15.3781918,11.6380045 C12.8323064,10.9362407 11.963771,8.47852395 11.963771,8.47852395 C11.8110443,8.44901109 11.8493762,6.74109366 11.1883616,6.69207022 C10.5267462,6.64279981 10.170464,6.88841096 9.20435656,6.69207022 C8.23764828,6.49572949 8.44144409,5.85743687 8.2887174,4.48255778 C8.25453994,4.17415686 8.25619136,3.95717082 8.28272988,3.80112099 Z M20.9991771,11.8770357 C20.9997251,11.9179585 21,11.9589471 21,12 C21,16.9406923 17.0188468,20.9515364 12.0895088,20.9995641 C16.970233,20.9503326 20.9337111,16.888438 20.9991771,11.8770357 Z"
                        fill="#FF5E8A"
                        opacity="0.3"
                      />
                    </g>
                  ),
                },
              ]}
            />
          </div>
          <div className="col-lg-6 col-md-6 mb-4">
            {" "}
            <StatsCard
              data={[
                {
                  statsInfo: `${stats?.venue_count}`,
                  title: "Total Stores",
                  icon: (
                    <g
                      stroke="none"
                      strokeWidth={1}
                      fill="none"
                      fillRule="evenodd"
                    >
                      <rect x={0} y={0} width={24} height={24} />
                      <path
                        d="M13.5,21 L13.5,18 C13.5,17.4477153 13.0522847,17 12.5,17 L11.5,17 C10.9477153,17 10.5,17.4477153 10.5,18 L10.5,21 L5,21 L5,4 C5,2.8954305 5.8954305,2 7,2 L17,2 C18.1045695,2 19,2.8954305 19,4 L19,21 L13.5,21 Z M9,4 C8.44771525,4 8,4.44771525 8,5 L8,6 C8,6.55228475 8.44771525,7 9,7 L10,7 C10.5522847,7 11,6.55228475 11,6 L11,5 C11,4.44771525 10.5522847,4 10,4 L9,4 Z M14,4 C13.4477153,4 13,4.44771525 13,5 L13,6 C13,6.55228475 13.4477153,7 14,7 L15,7 C15.5522847,7 16,6.55228475 16,6 L16,5 C16,4.44771525 15.5522847,4 15,4 L14,4 Z M9,8 C8.44771525,8 8,8.44771525 8,9 L8,10 C8,10.5522847 8.44771525,11 9,11 L10,11 C10.5522847,11 11,10.5522847 11,10 L11,9 C11,8.44771525 10.5522847,8 10,8 L9,8 Z M9,12 C8.44771525,12 8,12.4477153 8,13 L8,14 C8,14.5522847 8.44771525,15 9,15 L10,15 C10.5522847,15 11,14.5522847 11,14 L11,13 C11,12.4477153 10.5522847,12 10,12 L9,12 Z M14,12 C13.4477153,12 13,12.4477153 13,13 L13,14 C13,14.5522847 13.4477153,15 14,15 L15,15 C15.5522847,15 16,14.5522847 16,14 L16,13 C16,12.4477153 15.5522847,12 15,12 L14,12 Z"
                        fill="#FF5E8A"
                      />
                      <rect
                        fill="#FFFFFF"
                        x={13}
                        y={8}
                        width={3}
                        height={3}
                        rx={1}
                      />
                      <path
                        d="M4,21 L20,21 C20.5522847,21 21,21.4477153 21,22 L21,22.4 C21,22.7313708 20.7313708,23 20.4,23 L3.6,23 C3.26862915,23 3,22.7313708 3,22.4 L3,22 C3,21.4477153 3.44771525,21 4,21 Z"
                        fill="#FF5E8A"
                        opacity="0.3"
                      />
                    </g>
                  ),
                },
              ]}
            />
          </div>
        </div>

        {/* <VendorPresenceMap
  locations={this.state.vendorLocations}
  loading={this.state.vendorMapLoading}

/> */}



<VendorPresenceMap
  locations={this.state.vendorLocations}
  loading={this.state.vendorMapLoading}
  defaultRadiusKm={5}
/>



        <ManageVendorsTable showVendorsSubTable={true} />
      </div>
    );
  }
}
